export const UserData = [
    {
        id: 1,
        title: "free time in a day",
        average: 5.07
    },
    {
        id: 2,
        title: "hours spent on digital entertainment",
        average: 2.82
    },
    {
        id: 3,
        title: "hours spent on social media",
        average: 1.63
    }
];